
document.addEventListener('DOMContentLoaded', () => {
  const menuOpen = document.querySelector('[data-menu-open]');
  const menuClose = document.querySelector('[data-menu-close]');
  const drawer = document.querySelector('[data-drawer]');

  if (menuOpen && menuClose && drawer) {
    const setMenu = (open) => {
      drawer.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      menuOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    menuOpen.addEventListener('click', () => setMenu(true));
    menuClose.addEventListener('click', () => setMenu(false));
    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenu(false));
    });
  }

  document.querySelectorAll('[data-editorial-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-carousel-viewport]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!viewport) return;

    const distance = () => Math.max(280, Math.min(viewport.clientWidth * 0.8, 760));

    if (prev) {
      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -distance(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        viewport.scrollBy({ left: distance(), behavior: 'smooth' });
      });
    }
  });

  document.querySelectorAll('.template-product .js-hover-video').forEach((video) => {
    video.muted = true;

    video.addEventListener('pointerenter', () => {
      if (window.matchMedia('(hover: hover)').matches) {
        video.play().catch(() => {});
      }
    });

    video.addEventListener('pointerleave', () => {
      video.pause();
    });
  });

  document.querySelectorAll('.template-product .js-hover-external-video').forEach((container) => {
    const iframe = container.querySelector('iframe');
    if (!iframe) return;

    const host = container.dataset.videoHost;
    const sendPlayerCommand = (action) => {
      if (!iframe.contentWindow) return;

      if (host === 'youtube') {
        if (action === 'play') {
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'mute', args: [] }), '*');
        }
        iframe.contentWindow.postMessage(JSON.stringify({
          event: 'command',
          func: action === 'play' ? 'playVideo' : 'pauseVideo',
          args: []
        }), '*');
      } else if (host === 'vimeo') {
        if (action === 'play') {
          iframe.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
        }
        iframe.contentWindow.postMessage(JSON.stringify({ method: action }), '*');
      }
    };

    container.addEventListener('pointerenter', () => {
      if (window.matchMedia('(hover: hover)').matches) sendPlayerCommand('play');
    });
    container.addEventListener('pointerleave', () => sendPlayerCommand('pause'));
  });
});
